import { collection, getDocs, doc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "../Firebase";

export const getEnquiries = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "enquiries"));
    const list = [];
    querySnapshot.forEach((doc) => {
      list.push({ ...doc.data(), id: doc.id });
    });
    list.sort((a, b) => b.id.localeCompare(a.id));
    return list;
  } catch (error) {
    console.error("Error fetching enquiries from Firestore: ", error);
    throw error;
  }
};

export const saveEnquiry = async (enquiry, isNew = false) => {
  try {
    const docRef = doc(db, "enquiries", enquiry.id);
    await setDoc(docRef, enquiry, { merge: true });

    if (isNew) {
      try {
        const categoryMap = {
          sales: 'Generator Sales',
          rental: 'Generator Rental',
          maintenance: 'Generator Maintenance & AMC',
          solar: 'Solar Installation',
          panels: 'Electrical Panels',
          'cutting-tools': 'Cutting Tools',
          telecom: 'Telecom Services',
          'contact-us': 'General Enquiry'
        };

        const category = categoryMap[enquiry.type] || enquiry.type || 'General Enquiry';

        const payload = {
          _subject: `New Green Gusto Enquiry: ${category} from ${enquiry.name}`,
          _captcha: 'false',
          _template: 'table',
          "Enquiry Category": category,
          "Enquiry ID": enquiry.id,
          "Submitted On": enquiry.date || new Date().toISOString().replace('T', ' ').slice(0, 16),
          "Customer Name": enquiry.name,
          "Phone Number": enquiry.phone,
          "Email Address": enquiry.email || 'Not Provided'
        };

        // Type specific details
        if (enquiry.type === 'sales') {
          if (enquiry.productName) payload["Requested Product"] = enquiry.productName;
          if (enquiry.productId) payload["Product ID"] = enquiry.productId;
          if (enquiry.capacity) payload["Requested Capacity"] = enquiry.capacity;
          if (enquiry.city) payload["City"] = enquiry.city;
        } else if (enquiry.type === 'rental') {
          if (enquiry.productName) payload["Rental Plan"] = enquiry.productName;
          if (enquiry.companyName) payload["Company Name"] = enquiry.companyName;
          if (enquiry.capacity) payload["Generator Capacity"] = enquiry.capacity;
          if (enquiry.duration) payload["Rental Duration"] = enquiry.duration;
          if (enquiry.siteLocation) payload["Site Location"] = enquiry.siteLocation;
        } else if (enquiry.type === 'maintenance') {
          if (enquiry.city) payload["Organization Name"] = enquiry.city;
          if (enquiry.capacity) payload["Generator Capacity"] = enquiry.capacity;
          if (enquiry.serviceNeeded) payload["Service Needed"] = enquiry.serviceNeeded;
          if (enquiry.segment) payload["Industry Segment"] = enquiry.segment;
        } else if (enquiry.type === 'solar') {
          if (enquiry.city) payload["Installation City"] = enquiry.city;
          if (enquiry.capacity) payload["System Capacity"] = enquiry.capacity;
        } else if (enquiry.type === 'panels') {
          if (enquiry.city) payload["City"] = enquiry.city;
        } else if (enquiry.type === 'cutting-tools') {
          if (enquiry.city) payload["City"] = enquiry.city;
        } else if (enquiry.type === 'telecom') {
          if (enquiry.productName) payload["Telecom Service"] = enquiry.productName;
          if (enquiry.city) payload["Company & Region"] = enquiry.city;
        } else if (enquiry.type === 'contact-us') {
          if (enquiry.city) payload["City"] = enquiry.city;
          if (enquiry.enquiryType) payload["Enquiry Type"] = enquiry.enquiryType;
        }

        // Message
        payload["Message/Details"] = enquiry.message || 'No message provided';

        await fetch("https://formsubmit.co/ajax/info@green-gusto.com", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(payload)
        });
      } catch (emailError) {
        console.error("Error sending enquiry notification email: ", emailError);
      }
    }
  } catch (error) {
    console.error("Error saving enquiry: ", error);
    throw error;
  }
};

export const deleteEnquiryDoc = async (id) => {
  try {
    const docRef = doc(db, "enquiries", id);
    await deleteDoc(docRef);
  } catch (error) {
    console.error("Error deleting enquiry: ", error);
    throw error;
  }
};
